export const emptySetSignups = ' has no signups yet';
